import { t } from "@/i18n-js/instance";
import { useAudienceInfiniteQuery } from "@/react/hooks/useAudienceInfiniteQuery";
import type { ExpandableAccordionItem } from "../shared/ExpandableAccordion";
import { ExpandableAccordion } from "../shared/ExpandableAccordion";

const pendingRequestsFilter = {
  id: "connections-pending-recipient",
  key: "connections",
  status: "pending",
  role: "recipient",
};

export const PendingConnections = () => {
  const pendingConnectionsQuery = useAudienceInfiniteQuery({
    filters: [pendingRequestsFilter],
    perPage: 2,
  });
  const pendingConnections = pendingConnectionsQuery.audience || [];
  const hasMorePending = Boolean(pendingConnectionsQuery.hasNextPage);

  const items: ExpandableAccordionItem[] = pendingConnections.map(item => ({
    id: `${item.id}`,
    person: item,
    type: "connection",
  }));

  return (
    <ExpandableAccordion
      title={t("members_directory.grow.requests")}
      items={items}
      totalCount={pendingConnectionsQuery.totalQueryAudience ?? 0}
      isLoading={Boolean(pendingConnectionsQuery.isLoading)}
      hasMore={hasMorePending}
      fetchNextPage={() => pendingConnectionsQuery.fetchNextPage()}
      isFetchingNextPage={Boolean(pendingConnectionsQuery.isFetchingNextPage)}
      className="mx-2"
    />
  );
};
